import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import templateUrl from "emun.prospect/prospect-convert-prompt.htm";
import { prepTagsForSave } from "servicestack/tags/_config";
import prospectConfig from "emun.prospect/prospect.config";

function ProspectConvertPromptController(
  $rootScope,
  $uibModalInstance,
  options
) {
  var $ctrl = this;
  $ctrl.prospect = options.prospect;
  $ctrl.prospectConfig = prospectConfig;
  $ctrl.mode = "new";
  var bus = ($ctrl.bus = new ServiceBus($rootScope));
  $ctrl.title = options.title || "CONVERT PROSPECT";
  $ctrl.save = $ctrl.submit = function() {
    let $ctrl = this;
    $ctrl.prospect.status = "Converted";
    if ($ctrl.mode == "new") {
      $ctrl.prospect.customerId = "";
    }
    const req = {
      ...$ctrl.prospect,
      tags: prepTagsForSave($ctrl.prospect.tags)
    };
    $ctrl.bus.send("UpdateProspect.json", req).then(res => {
      res.data.mode = $ctrl.mode;
      $uibModalInstance.close(res);
    });
  };
  $ctrl.dismiss = function() {
    $uibModalInstance.dismiss();
  };
  $ctrl.findRetailers = function(val) {
    let $ctrl = this;
    let url = `/QueryRetailersSearch.json?Take=5&Status=Active&Search=${val}&OrderBy=CompanyName`; //
    console.log("QueryRetailersSearch.$item", url);
    return $ctrl.bus.send(url).then(res => res.data.results);
  };
  $ctrl.selectRetailer = function(val) {
    const $ctrl = this;
    $ctrl.prospect.customerId = val.id;
  };
}

export default {
  open(options) {
    return modals.open(
      angular.extend(
        {
          size: "md",
          templateUrl: templateUrl,
          resolve: {
            options: () => options
          },
          controller: ProspectConvertPromptController,
          controllerAs: "$ctrl"
        },
        (options || {}).modal
      )
    ).result;
  }
};